import { CreateProductSpecification, ProductSpecification } from "../../Models/ProductSpecification";
import api from "../axios";

export const productSpecificationService = {
  create: async (data: CreateProductSpecification) => {
    const response = await api.post('/product-specification', data);
    return response.data;
  },

  update: async (data: ProductSpecification) => {
    const response = await api.put('/product-specification', data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/product-specification/${id}`);
    return response.data;
  }
};
